module.exports = __webpack_public_path__ + "static/media/footer-logo.be8d351d.svg";